<template>
    <div class="page-customer">
        <send-card-sms-dialog
            :visible.sync="sendDialogVisible"
            :customer="currentSendCustomer"
            @success="onSendSuccess"
        />
        <div class="title-row">
            <div>
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item>管理系统</el-breadcrumb-item>
                    <el-breadcrumb-item>{{
                        $route.meta.breadcrumb
                    }}</el-breadcrumb-item>
                </el-breadcrumb>
                <h1 class="page-title">{{ $route.meta.title }}</h1>
            </div>
            <div class="active-users">
                <el-tooltip content="在线用户示意" placement="bottom">
                    <div class="avatar-stack">
                        <span
                            v-for="(c, i) in stackColors"
                            :key="i"
                            class="stack-dot"
                            :style="{ background: c, zIndex: 10 - i }"
                        />
                        <span class="stack-more">+12</span>
                    </div>
                </el-tooltip>
                <span class="active-label">当前活跃 4,291</span>
            </div>
        </div>

        <div class="content-card">
            <div class="toolbar-row">
                <div class="filter-row">
                    <el-input
                        v-model="searchName"
                        class="filter-input"
                        clearable
                        placeholder="输入客户姓名..."
                        prefix-icon="el-icon-user"
                        @keyup.enter.native="onSearch"
                    />
                    <el-select
                        v-model="writeOffStatusFilter"
                        placeholder="是否需要核销"
                        class="filter-select"
                        @change="onSearch"
                    >
                        <el-option label="全部" value=" " />
                        <el-option label="需要核销" value="1" />
                        <el-option label="不需要核销" value="2" />
                    </el-select>
                    <el-input
                        @keyup.enter.native="onSearch"
                        v-model="searchPhone"
                        class="filter-input"
                        clearable
                        placeholder="输入手机号..."
                        prefix-icon="el-icon-phone"
                    />
                    <el-select
                        v-model="cardBindStatusFilter"
                        placeholder="绑定状态"
                        class="filter-select"
                        @change="onSearch"
                    >
                        <el-option label="全部" value=" " />
                        <el-option label="已绑定" value="2" />
                        <el-option label="未绑定" value="1" />
                    </el-select>
                    <el-select
                        v-model="redeemStatusFilter"
                        placeholder="核销状态"
                        class="filter-select"
                        @change="onSearch"
                    >
                        <el-option label="全部" value=" " />
                        <el-option label="未核销" value="1" />
                        <el-option label="核销中" value="2" />
                        <el-option label="已核销" value="3" />
                    </el-select>
                    <div class="filter-actions">
                        <el-button
                            class="btn-black"
                            type="primary"
                            icon="el-icon-search"
                            @click="fetchData"
                            >查询</el-button
                        >
                        <el-button
                            icon="el-icon-refresh"
                            @click="handleResetFilters"
                            >重置</el-button
                        >
                    </div>
                </div>
                <div class="toolbar-actions">
                    <el-button
                        class="btn-black"
                        type="primary"
                        icon="el-icon-plus"
                        @click="openAddDialog"
                        >新增客户</el-button
                    >
                    <el-button icon="el-icon-document" @click="openImportDialog"
                        >Excel导入</el-button
                    >
                    <el-button icon="el-icon-upload2" @click="handleExport"
                        >导出</el-button
                    >
                    <el-button
                        icon="el-icon-refresh"
                        circle
                        @click="fetchData"
                    />
                </div>
            </div>

            <el-table
                :data="tableData"
                v-loading="loading"
                stripe
                border
                style="width: 100%"
                height="60vh"
            >
                <el-table-column
                    align="center"
                    label="客户姓名"
                    min-width="130"
                >
                    <template slot-scope="scope">
                        <div class="name-cell">
                            <!-- <span class="name-avatar">{{
                                scope.row.ownerName.charAt(0)
                            }}</span> -->
                            <span>{{ scope.row.ownerName }}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="手机号" min-width="130">
                    <template slot-scope="scope">
                        {{
                            scope.row.ownerPhone
                                ? scope.row.ownerPhone.replace(
                                      /(\d{3})\d{4}(\d{4})/,
                                      '$1****$2'
                                  )
                                : ''
                        }}
                    </template>
                </el-table-column>
                <el-table-column align="center" label="绑定卡密" width="120">
                    <template slot-scope="scope">
                        {{
                            scope.row.bindingCard != null
                                ? `${scope.row.bindingCard} 张`
                                : ''
                        }}
                    </template>
                </el-table-column>
                <el-table-column align="center" label="银行卡号" width="140">
                    <template slot-scope="scope">
                        {{
                            scope.row.bankNumber
                                ? scope.row.bankNumber.replace(
                                      /^(\d{4})\d+(\d{4})$/,
                                      '$1****$2'
                                  )
                                : ''
                        }}
                    </template>
                </el-table-column>
                <el-table-column align="center" label="账户类型" width="110">
                    <template slot-scope="scope">
                        {{ formatAccountType(scope.row.accountType) }}
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="ownerStatus"
                    label="是否需要批量审核"
                    width="150"
                >
                    <template slot-scope="scope">
                        <el-tag
                            v-if="scope.row.ownerStatus === '1'"
                            type="success"
                            size="small"
                            >需要核销</el-tag
                        >
                        <el-tag
                            v-else-if="scope.row.ownerStatus === '2'"
                            type="info"
                            size="small"
                            >不需要核销</el-tag
                        >
                    </template>
                </el-table-column>
                <el-table-column align="center" label="核销状态" width="110">
                    <template slot-scope="scope">
                        <el-tag
                            v-if="scope.row.redeemStatus === '1'"
                            type="warning"
                            size="small"
                            >未核销</el-tag
                        >
                        <el-tag
                            v-else-if="scope.row.redeemStatus === '2'"
                            type="primary"
                            size="small"
                            >核销中</el-tag
                        >
                        <el-tag
                            v-else-if="scope.row.redeemStatus === '3'"
                            type="success"
                            size="small"
                            >已核销</el-tag
                        >
                    </template>
                </el-table-column>
                <el-table-column align="center" label="充值金额" width="130">
                    <template slot-scope="scope">
                        {{
                            scope.row.rechargeMoney != null
                                ? `¥${Number(
                                      scope.row.rechargeMoney
                                  ).toLocaleString('zh-CN', {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2
                                  })}`
                                : ''
                        }}
                    </template>
                </el-table-column>
                <el-table-column align="center" label="已核销金额" width="130">
                    <template slot-scope="scope">
                        {{
                            scope.row.redeemSuccessMoney != null
                                ? `¥${Number(
                                      scope.row.redeemSuccessMoney
                                  ).toLocaleString('zh-CN', {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2
                                  })}`
                                : ''
                        }}
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="createTime"
                    label="注册时间"
                    min-width="180"
                />
                <el-table-column
                    align="center"
                    label="操作"
                    width="160"
                    fixed="right"
                >
                    <template slot-scope="scope">
                        <el-button
                            v-if="scope.row.redeemStatus != 3"
                            type="text"
                            icon="el-icon-position"
                            @click="handleSend(scope.row)"
                            title="发送"
                        />
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.row)"
                            title="编辑"
                        />
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            class="text-danger-action"
                            @click="handleDelete(scope.row)"
                            title="删除"
                        />
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination-bar">
                <span class="pagination-info"
                    >显示 {{ tableData.length }} 条，共 {{ total }} 名客户</span
                >
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="total"
                    :page-size="pageSize"
                    :current-page.sync="currentPage"
                    @current-change="onPageChange"
                />
            </div>
        </div>

        <el-dialog
            title="批量导入客户"
            :visible.sync="importDialogVisible"
            width="560px"
            custom-class="batch-import-customer-dialog"
            :close-on-click-modal="false"
            append-to-body
            @closed="onImportDialogClosed"
        >
            <div class="import-guide-box">
                <div class="import-guide-title">
                    <i class="el-icon-info" />
                    <span>操作指引</span>
                </div>
                <p class="import-guide-desc">
                    请先下载我们的标准化模板，按表格格式填写后上传，系统会自动过滤重复手机号。
                </p>
                <el-button
                    type="text"
                    icon="el-icon-download"
                    class="import-template-link"
                    @click="downloadImportTemplate"
                >
                    下载导入模板.xlsx
                </el-button>
            </div>

            <el-upload
                ref="importUpload"
                class="import-upload-block"
                drag
                action=""
                :http-request="noopUploadRequest"
                :auto-upload="false"
                :limit="1"
                :on-change="handleImportFileChange"
                :on-remove="handleImportFileRemove"
                accept=".xlsx,.xls"
            >
                <i class="el-icon-upload" />
                <div class="el-upload__text">点击上传或拖拽文件到这里</div>
                <div class="el-upload__tip" slot="tip">
                    仅支持 .xlsx 或 .xls 格式，文件大小不超过 10MB
                </div>
            </el-upload>

            <span slot="footer" class="import-dialog-footer">
                <el-button @click="importDialogVisible = false">关闭</el-button>
                <el-button
                    class="btn-black"
                    type="primary"
                    :loading="importSubmitting"
                    @click="startBatchImport"
                >
                    开始导入
                </el-button>
            </span>
        </el-dialog>

        <el-dialog
            :title="isEdit ? '编辑客户信息' : '新增客户信息'"
            :visible.sync="addDialogVisible"
            width="480px"
            custom-class="add-customer-dialog"
            :close-on-click-modal="false"
            @closed="onAddDialogClosed"
        >
            <el-form
                ref="addForm"
                :model="addForm"
                :rules="addFormRules"
                label-position="top"
                class="add-customer-form"
            >
                <el-form-item label="客户姓名" prop="name">
                    <el-input
                        v-model="addForm.name"
                        clearable
                        placeholder="请输入客户姓名"
                    />
                </el-form-item>
                <el-form-item label="手机号码" prop="phone">
                    <el-input
                        v-model="addForm.phone"
                        clearable
                        maxlength="11"
                        placeholder="请输入手机号码"
                        @input="
                            (val) => (addForm.phone = val.replace(/\D/g, ''))
                        "
                    />
                </el-form-item>
                <el-form-item label="充值金额" prop="recharge">
                    <el-input
                        v-model="addForm.recharge"
                        :disabled="isEdit"
                        clearable
                        placeholder="请输入充值金额"
                        @input="
                            (val) =>
                                (addForm.recharge = val.replace(/[^\d.]/g, ''))
                        "
                    />
                </el-form-item>
                <el-form-item label="银行卡号" prop="cardNumber">
                    <el-input
                        v-model="addForm.cardNumber"
                        clearable
                        placeholder="请输入银行卡号"
                    />
                </el-form-item>
                <el-form-item label="账户类型" prop="accountType">
                    <el-select
                        v-model="addForm.accountType"
                        placeholder="请选择账户类型"
                        style="width: 100%"
                        clearable
                    >
                        <el-option
                            v-for="item in accountTypeOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        />
                    </el-select>
                </el-form-item>

                <el-form-item label="是否需要批量核销" prop="needWriteOff">
                    <el-select
                        v-model="addForm.needWriteOff"
                        placeholder="请选择"
                        style="width: 100%"
                        clearable
                    >
                        <el-option label="需要核销" value="1" />
                        <el-option label="不需要核销" value="2" />
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addDialogVisible = false">取消</el-button>
                <el-button
                    class="btn-black"
                    type="primary"
                    :loading="addSubmitting"
                    @click="submitAddCustomer"
                >
                    {{ isEdit ? '确认修改' : '确认添加' }}
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import SendCardSmsDialog from '@/components/SendCardSmsDialog.vue'
import {
    getCustomerList,
    addCustomer,
    delCustomer,
    importOwner,
    updateCustomer,
    exportOwner,
    getOwnerDetail
} from '@/api/customer'

const ACCOUNT_TYPE_MAP = {
    0: '对公账户',
    1: '对私账户'
}

const accountTypeOptions = [
    { label: '对公账户', value: 0 },
    { label: '对私账户', value: 1 }
]

export default {
    components: {
        SendCardSmsDialog
    },
    name: 'Customer',
    data() {
        const validatePhone = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请输入手机号码'))
                return
            }
            const phoneReg = /^1[3-9]\d{9}$/
            if (!phoneReg.test(value)) {
                callback(new Error('手机号格式不正确，请输入11位手机号码'))
                return
            }
            callback()
        }
        return {
            searchName: '',
            searchPhone: '',
            writeOffStatusFilter: '',
            cardBindStatusFilter: '',
            redeemStatusFilter: '',
            currentPage: 1,
            pageSize: 10,
            total: 0,
            loading: false,
            importDialogVisible: false,
            importSubmitting: false,
            pendingImportFile: null,
            addDialogVisible: false,
            addSubmitting: false,
            isEdit: false,
            editingOwnerId: null,
            sendDialogVisible: false,
            currentSendCustomer: {},
            accountTypeOptions,
            addForm: {
                name: '',
                phone: '',
                cardNumber: '',
                accountType: '',
                recharge: '',
                needWriteOff: '1'
            },
            addFormRules: {
                name: [
                    {
                        required: true,
                        message: '请输入客户姓名',
                        trigger: 'blur'
                    }
                ],
                recharge: [
                    {
                        required: true,
                        message: '请输入充值金额',
                        trigger: 'blur'
                    }
                ],
                phone: [
                    {
                        required: true,
                        validator: validatePhone,
                        trigger: 'blur'
                    }
                ]
            },
            stackColors: [
                '#409EFF',
                '#67C23A',
                '#E6A23C',
                '#F56C6C',
                '#909399'
            ],
            tableData: []
        }
    },
    mounted() {
        this.onSearch()
    },
    methods: {
        formatAccountType(value) {
            if (value === null || value === undefined || value === '') return ''
            return (
                ACCOUNT_TYPE_MAP[value] || ACCOUNT_TYPE_MAP[Number(value)] || ''
            )
        },
        onSearch() {
            this.currentPage = 1
            this.fetchData()
        },
        async fetchData() {
            this.loading = true
            try {
                const params = {
                    ownerName: this.searchName,
                    ownerPhone: this.searchPhone,
                    ownerStatus: this.writeOffStatusFilter.trim(),
                    bindingCard: this.cardBindStatusFilter.trim(),
                    redeemStatus: this.redeemStatusFilter.trim(),
                    pageNum: this.currentPage,
                    pageSize: this.pageSize
                }
                const res = await getCustomerList(params)
                this.tableData = res.rows
                this.total = res.total || 0
            } catch {
                // 错误已在 request.js 响应拦截器中处理
            } finally {
                this.loading = false
            }
        },
        handleResetFilters() {
            this.searchName = ''
            this.searchPhone = ''
            this.writeOffStatusFilter = ''
            this.cardBindStatusFilter = ''
            this.redeemStatusFilter = ''
            this.currentPage = 1
            this.fetchData()
            this.$message.info('筛选条件已重置')
        },
        onPageChange(page) {
            this.currentPage = page
            this.fetchData()
        },
        openAddDialog() {
            this.isEdit = false
            this.editingOwnerId = null
            this.addDialogVisible = true
            this.$nextTick(() => {
                if (this.$refs.addForm) {
                    this.$refs.addForm.clearValidate()
                    this.$refs.addForm.resetFields()
                }
            })
        },
        onAddDialogClosed() {
            this.addSubmitting = false
            this.isEdit = false
            this.editingOwnerId = null
        },
        async submitAddCustomer() {
            this.$refs.addForm.validate(async (valid) => {
                if (!valid) return
                this.addSubmitting = true
                try {
                    if (this.isEdit) {
                        await updateCustomer({
                            ownerId: this.editingOwnerId,
                            ownerName: this.addForm.name,
                            ownerPhone: this.addForm.phone,
                            bankNumber: this.addForm.cardNumber,
                            accountType: this.addForm.accountType,
                            ownerStatus: this.addForm.needWriteOff
                        })
                        this.$message.success('修改成功')
                    } else {
                        await addCustomer({
                            ownerName: this.addForm.name,
                            ownerPhone: this.addForm.phone,
                            bankNumber: this.addForm.cardNumber,
                            accountType: this.addForm.accountType,
                            rechargeMoney: this.addForm.recharge
                                ? Number(this.addForm.recharge)
                                : 0,
                            ownerStatus: this.addForm.needWriteOff
                        })
                        this.$message.success('新增客户成功')
                    }
                    this.addDialogVisible = false
                    // 回到第一页刷新列表
                    this.currentPage = 1
                    this.fetchData()
                } catch {
                    // 错误已在 request.js 响应拦截器中处理
                } finally {
                    this.addSubmitting = false
                }
            })
        },
        noopUploadRequest() {},
        openImportDialog() {
            this.importDialogVisible = true
        },
        onImportDialogClosed() {
            this.importSubmitting = false
            this.pendingImportFile = null
            if (this.$refs.importUpload) {
                this.$refs.importUpload.clearFiles()
            }
        },
        downloadImportTemplate() {
            const html = `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel">
<meta http-equiv="Content-Type" content="text/html; charset=utf-8">
<body><table border="1"><tr><th>客户姓名</th><th>手机号</th><th>银行卡号</th><th>账户类型</th><th>是否需要批量核销</th><th>充值金额</th></tr>
<tr><td>示例客户</td><td>13800000000</td><td>20282981938198</td><td>对私账户</td><td>需要核销</td><td>100</td></tr></table></body></html>`
            const blob = new Blob([`\ufeff${html}`], {
                type: 'application/vnd.ms-excel;charset=utf-8'
            })
            const url = URL.createObjectURL(blob)
            const a = document.createElement('a')
            a.href = url
            a.download = '客户导入模板.xls'
            a.click()
            URL.revokeObjectURL(url)
            this.$message.success('模板已开始下载')
        },
        beforeImportUpload(file) {
            const ok = /\.(xlsx|xls)$/i.test(file.name)
            const max = 10 * 1024 * 1024
            if (!ok) {
                this.$message.error('仅支持 .xlsx 或 .xls 格式')
                return false
            }
            if (file.size > max) {
                this.$message.error('文件大小不能超过 10MB')
                return false
            }
            return true
        },
        handleImportFileChange(file, fileList) {
            console.log(file, fileList)
            const raw = file.raw
            if (!raw) return
            if (!this.beforeImportUpload(raw)) {
                this.$nextTick(() => {
                    if (this.$refs.importUpload)
                        this.$refs.importUpload.clearFiles()
                })
                return
            }
            this.pendingImportFile = raw
        },
        handleImportFileRemove() {
            this.pendingImportFile = null
        },
        async startBatchImport() {
            if (!this.pendingImportFile) {
                this.$message.warning('请先选择要导入的文件')
                return
            }
            this.importSubmitting = true
            try {
                const formData = new FormData()
                formData.append('file', this.pendingImportFile)
                await importOwner(formData)
                this.importDialogVisible = false
                this.$message.success('导入成功')
                this.currentPage = 1
                this.fetchData()
            } catch {
                // 错误已在 request.js 响应拦截器中处理
            } finally {
                this.importSubmitting = false
            }
        },
        async handleExport() {
            try {
                const params = {
                    ownerName: this.searchName,
                    ownerPhone: this.searchPhone,
                    ownerStatus: this.writeOffStatusFilter,
                    bindingCard: this.cardBindStatusFilter,
                    redeemStatus: this.redeemStatusFilter
                }
                const blob = await exportOwner(params)
                const url = window.URL.createObjectURL(new Blob([blob]))
                const link = document.createElement('a')
                link.href = url
                link.download = '客户数据.xlsx'
                link.click()
                window.URL.revokeObjectURL(url)
                this.$message.success('导出成功')
            } catch {}
        },
        handleSend(row) {
            this.currentSendCustomer = {
                name: row.ownerName,
                phone: row.ownerPhone,
                bindingCard: row.bindingCard,
                rechargeMoney: row.rechargeMoney,
                ownerId: row.ownerId
            }
            this.sendDialogVisible = true
        },
        onSendSuccess(data) {
            console.log('发送成功:', data)
        },
        async handleEdit(row) {
            this.isEdit = true
            if (this.$refs.addForm) {
                this.$refs.addForm.clearValidate()
            }
            this.editingOwnerId = row.ownerId
            try {
                const res = await getOwnerDetail(row.ownerId)
                const data = res.data
                this.addForm = {
                    name: data.ownerName,
                    phone: data.ownerPhone,
                    cardNumber: data.bankNumber,
                    accountType:
                        data.accountType != null ? Number(data.accountType) : 1,
                    recharge:
                        data.rechargeMoney != null
                            ? String(data.rechargeMoney)
                            : '',
                    needWriteOff: data.ownerStatus
                }
            } catch {
                // 接口失败时使用列表数据兜底
                this.addForm = {
                    name: row.ownerName,
                    phone: row.ownerPhone,
                    cardNumber: row.bankNumber,
                    accountType:
                        row.accountType != null ? Number(row.accountType) : 1,
                    recharge:
                        row.rechargeMoney != null
                            ? String(row.rechargeMoney)
                            : '',
                    needWriteOff: row.ownerStatus
                }
            }
            this.addDialogVisible = true
            this.$nextTick(() => {
                if (this.$refs.addForm) {
                    this.$refs.addForm.clearValidate()
                }
            })
        },
        handleDelete(row) {
            this.$confirm(`确定删除客户 ${row.ownerName}？`, '删除确认', {
                type: 'warning',
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            })
                .then(async () => {
                    try {
                        await delCustomer(row.ownerId)
                        this.$message.success('删除成功')
                        this.fetchData()
                    } catch {
                        // 错误已在 request.js 响应拦截器中处理
                    }
                })
                .catch(() => {})
        }
    }
}
</script>

<style scoped>
.filter-row {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    flex: 1;
}

.filter-input {
    width: 180px;
}

.filter-select {
    width: 180px;
}

.filter-actions {
    display: flex;
    gap: 8px;
    margin-left: 8px;
}

.title-row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
}

.active-users {
    display: flex;
    align-items: center;
    gap: 12px;
    padding-top: 22px;
}

.avatar-stack {
    display: flex;
    align-items: center;
}

.stack-dot {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 2px solid #fff;
    margin-left: -10px;
    position: relative;
}

.stack-dot:first-child {
    margin-left: 0;
}

.stack-more {
    margin-left: 6px;
    font-size: 13px;
    color: #606266;
    font-weight: 500;
}

.active-label {
    font-size: 14px;
    color: #606266;
}

.name-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
}

.name-avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #ecf5ff;
    color: #409eff;
    font-size: 14px;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.pagination-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 16px;
}

.pagination-info {
    font-size: 13px;
    color: #606266;
}

.import-guide-box {
    padding: 14px 16px;
    margin-bottom: 20px;
    background: #ecf5ff;
    border: 1px solid #d9ecff;
    border-radius: 6px;
}

.import-guide-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    font-weight: 600;
    color: #409eff;
    margin-bottom: 10px;
}

.import-guide-title i {
    font-size: 16px;
}

.import-guide-desc {
    margin: 0 0 10px;
    font-size: 13px;
    line-height: 1.6;
    color: #606266;
}

.import-template-link {
    padding: 0 !important;
    font-size: 13px;
}

.import-upload-block {
    width: 100%;
}

.import-upload-block >>> .el-upload {
    width: 100%;
}

.import-upload-block >>> .el-upload-dragger {
    width: 100%;
    padding: 28px 16px;
}

.import-dialog-footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
}

.add-customer-form {
    padding-top: 8px;
}
</style>

<style>
.batch-import-customer-dialog .el-dialog__body {
    padding-top: 12px;
    padding-bottom: 8px;
}

.add-customer-dialog .el-dialog__body {
    padding-top: 10px;
    padding-bottom: 8px;
}

.add-customer-dialog .dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

/* 修复固定列底部内容穿透问题 */
.page-customer .el-table__fixed-right {
    background: #fff;
    border-left: 1px solid #ebeef5;
}
.page-customer .el-table__fixed-right td,
.page-customer .el-table__fixed-right th {
    background: #fff;
}
/* 修复固定列与主表之前边框缺失、错位问题 */
.page-customer .el-table__body-wrapper .el-table__fixed-right .el-table__body {
    border-left: 1px solid #ebeef5;
}
</style>